import {
    ZHLPersonalizedNextStepExperience,
    ZHLPersonalizedNextStepState,
} from 'src/services/graphql/generated/graphql';

const FIRST_PARTY_EXPERIENCE_ELIGIBLE_STATES = [
    ZHLPersonalizedNextStepState.NEW_APPLICATION,
    ZHLPersonalizedNextStepState.VERIFIED_PREAPPROVAL,
    ZHLPersonalizedNextStepState.VERIFIED_PREAPPROVAL_NO_TRID_OUTSTANDING_TASKS,
    ZHLPersonalizedNextStepState.OUTSTANDING_TASKS,
    ZHLPersonalizedNextStepState.WAITING_TO_CLOSE,
];

export const isFirstPartyEligible = (
    state: ZHLPersonalizedNextStepState,
    experience: ZHLPersonalizedNextStepExperience
): boolean =>
    FIRST_PARTY_EXPERIENCE_ELIGIBLE_STATES.includes(state) &&
    experience === ZHLPersonalizedNextStepExperience.FIRST_PARTY;
